import { NegativeSolidIcon } from "#icons";
import {
  Label,
  TagList,
  TagGroup as RaTagGroup,
  Text,
  type TagGroupProps as RATagGroupProps,
  type TagListProps,
} from "react-aria-components";

export interface TagGroupProps<T>
  extends
    Omit<RATagGroupProps, "children">,
    Pick<TagListProps<T>, "items" | "children" | "renderEmptyState"> {
  label?: string;
  description?: string;
  errorMessage?: string;
  tagListClassName?: string;
}

export function TagGroup<T extends object>({
  label,
  description,
  errorMessage,
  items,
  children,
  renderEmptyState,
  tagListClassName,
  ...props
}: TagGroupProps<T>) {
  return (
    <RaTagGroup {...props}>
      {label ? <Label className="text-label-small">{label}</Label> : null}
      <TagList className={tagListClassName} items={items} renderEmptyState={renderEmptyState}>
        {children}
      </TagList>
      {description ? (
        <Text className="text-label-small" slot="description">
          {description}
        </Text>
      ) : null}
      {errorMessage ? (
        <div className="gap-x-2xs flex items-center gap-1">
          <NegativeSolidIcon />
          <Text className="text-label-small text-text-negative" slot="errorMessage">
            {errorMessage}
          </Text>
        </div>
      ) : null}
    </RaTagGroup>
  );
}
